 <template>
  <div class="relativecls">

    <div class="explain-link">《各種説明
    <b-icon icon="blank"></b-icon><b-link target=”_blank” href="http://kit.socinno.com/3_2_ai/">AIモデル(CNN)</b-link>
    <b-icon icon="blank"></b-icon><b-link target=”_blank” href="http://kit.socinno.com/3_1_ai/#optimiz">Optimizer(最適化手法)</b-link>
    <b-icon icon="blank"></b-icon><b-link target=”_blank” href="http://kit.socinno.com/3_1_ai/#loss">Loss(損失関数)</b-link>
    <b-icon icon="blank"></b-icon><b-link target=”_blank” href="http://kit.socinno.com/3_1_ai/#activ">Activation(活性化関数)</b-link>》</div>

    <InSampleSw v-if="manualInputFlag==0"></InSampleSw>
    <b-row v-if="manualInputFlag==1"><b-col><div class="row"><br/></div></b-col></b-row>
    <InManualSw v-if="manualInputFlag==2"></InManualSw>

    <b-row>
      <!-- ################## Input ##################-->
      <!-- Input Sample-->
      <b-col v-if="manualInputFlag==0" class="relativecls">
        <InputMnist v-if="manualInputFlag==0 && this.samplebtn === 'MNIST'" ref="inmnist"></InputMnist>
        <InputKitdata v-if="manualInputFlag==0 && this.samplebtn === 'KITDATA'" ref="inkitdata"></InputKitdata>
        <b-icon icon="info" v-b-popover.hover.top="'全ての画像は28*28pxのGrayScaleでAIに学習されます'" class="ricon"></b-icon>
        <div class="rarrow" ><img src="../assets/rightarrow.png" alt="RightAllow"></div>
      </b-col>
      <!-- Input Upload-->
      <b-col v-if="manualInputFlag==1" class="relativecls">
        <InputUpload></InputUpload>
        <b-icon icon="info" v-b-popover.hover.top="'全ての画像は28*28pxのGrayScaleでAIに学習されます'" class="ricon"></b-icon>
        <div class="rarrow"><img src="../assets/rightarrow.png" alt="RightAllow"></div>
      </b-col>
      <!-- Input manual-->
      <b-col v-if="manualInputFlag==2" class="relativecls">
        <transition-group>
          <InputCard v-for="inp of inputs" v-bind:key="inp.id" :in_id="inp.id" :in_name="inp.name" :in_actb="inp.act" ref="inmanual"></InputCard>
        </transition-group>
        <b-button variant="outline-secondary" class="plus-input" @click="plusInput()">＋</b-button>
        <b-icon icon="info" v-b-popover.hover.top="'全ての画像は28*28pxのGrayScaleでAIに学習されます'" class="ricon"></b-icon>
        <div class="rarrow"><img src="../assets/rightarrow.png" alt="RightAllow"></div>
      </b-col>

      <!-- ################## Make Model ##################-->
      <b-col class="relativecls">
          <SetModel></SetModel>
          <div class="rarrow"><img src="../assets/rightarrow.png" alt="RightAllow"></div>
      </b-col>

      <!-- ################## Result OutPut ##################-->
      <b-col>
          <OutStudy ref="outstudy"></OutStudy>
      </b-col>
    </b-row>

    <br/><br/>
    <b-button variant="outline-primary" class="long_button" @click="doTrain" :disabled="trainBtnDisable">学習</b-button>
    <br/><br/>
    <strong><div id="dispmes" class="dispmes">{{dispMessage}}</div><div id="consoleev" class="dispmes"></div></strong>
    <b-progress :value="progbars.value" max=100 show-progress striped animated v-if="progbars.show"></b-progress>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InSampleSw from '@/components/InSampleSw.vue'
import InManualSw from '@/components/InManualSw.vue'
import InputCard from '@/components/InputCard.vue'
import InputMnist from '@/components/InputMnist.vue'
import InputKitdata from '@/components/InputKitdata.vue'
import InputUpload from '@/components/InputUpload.vue'
import OutStudy from '@/components/OutStudy.vue'
import SetModel from '@/components/SetModel.vue'

window.addEventListener('error', event => {
  console.log('consoleError')
  document.getElementById('consoleev').innerHTML = event.message
})
window.addEventListener('warn', event => {
  console.log('consoleWarn')
  document.getElementById('consoleev').innerHTML = event.message
})

export default {
  name: 'aitrain',
  data () {
    return {
      progbarOptions: {
        text: {
          color: '#FFFFFF',
          shadowEnable: true,
          shadowColor: '#000000',
          fontSize: 14,
          fontFamily: 'Helvetica',
          dynamicPosition: false,
          hideText: false
        },
        progress: {
          color: '#2dbd2d',
          backgroundColor: '#C0C0C0'
        },
        layout: {
          height: 35,
          width: 140,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'line'
        }
      }
    }
  },
  components: {
    InSampleSw,
    InputMnist,
    InputKitdata,
    InputUpload,
    InManualSw,
    InputCard,
    OutStudy,
    SetModel
  },
  computed: {
    ...mapState([ 'inputs', 'dispMessage', 'progbars', 'trainBtnDisable', 'manualInputFlag', 'samplebtn' ])
  },
  methods: {
    plusInput () {
      this.$store.dispatch('addInput')
    },
    doTrain () {
      this.$store.dispatch('setTrainDisable', true)
      this.$refs.outstudy.doAiTrain()
    },
    async loadImage () {
      // console.log('Aitrain_loadImage:' + this.manualInputFlag + ':' + this.samplebtn)
      if (this.manualInputFlag === 0 && this.samplebtn === 'MNIST') {
        await this.$refs.inmnist.refreshLoadImage()
      } else if (this.manualInputFlag === 0 && this.samplebtn === 'KITDATA') {
        await this.$refs.inkitdata.refreshLoadImage()
      } else if (this.manualInputFlag === 1) {
        // this.$refs.inmanual.refreshLoadImage() // mapGetterでVuexと同期済み
      }
    },
    async loadGraph () {
      await this.$refs.outstudy.updateChartData(true, true)
    }
  },
  created () {
    // this.plusInput() // 必ず2つは表示
    // this.plusInput() // 必ず2つは表示
  }
}
</script>

<style scoped>
.explain-link {
  position: absolute;
  top: -15px;
  right: -20px;
  font-size: 70%;
}
.ricon {
  position: absolute;
  top: 6px;
  left: 330px;
}
.rarrow {
  position: absolute;
  top: 35px;
  left: 355px;
}
.dispmes {
  font: outline;
  color: red;
}
.long_button {
  width: 500px;
  text-align: left;
  padding-left: 170px;
  letter-spacing: 140px;
}
.plus-input {
  height: 35px;
  width : 336px;
  border : dotted 1px #999 ;
}
.v-enter-active, .v-leave-active, .v-move {
  transition: transform 0.5s;
}
.v-enter, .v-leave-to {
  transform: translateX(-170%);
}
.v-leave-active {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/AiTrain.vue